module.exports = __webpack_public_path__ + "img/hairsalon3.113f8693.png";